import clsx from 'clsx';
import { Input } from '../../../../../components/Input';
import { useForm } from '../../../../../hooks/useForm';
import { SettingItemActions } from '../../SettingItemActions';
import React, { ChangeEvent, useState } from 'react';
import { SettingTag } from '../../SettingTag';

interface Props {
  index: number;
  fipsCode: CreateFipsCode;
  onRemove?(index: number): void;
  onSave?(item: CreateFipsCode, index: number): void;
}

interface Content extends Props {
  editing: boolean;
}

interface Form extends Content {
  values: CreateFipsCode;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
  updateField(field: keyof CreateFipsCode, value: any): void;
}

export const FIPSCode = (props: Props) => {
  const [editing, setEditing] = useState(false);
  const { fipsCode, index, onRemove = null, onSave = null } = props;
  const { values, onChange, updateField } = useForm<CreateFipsCode>(
    fipsCode,
    () => null
  );

  return (
    <div
      className={clsx('w-full inline-flex justify-between items-center gap-4')}
    >
      <EditFIPSCode
        editing={editing}
        onChange={onChange}
        updateField={updateField}
        values={values}
        {...props}
      />
      <FIPSCodeContent editing={editing} {...props} />
      {onRemove && onSave ? (
        <SettingItemActions
          canSave={values.code.trim() !== '' && values.county.trim() !== ''}
          editing={editing}
          onEdit={() => setEditing(true)}
          onRemove={() => onRemove(index)}
          onSave={() => {
            onSave(values, index);
            setEditing(false);
          }}
          onCancel={() => setEditing(false)}
        />
      ) : null}
    </div>
  );
};

const EditFIPSCode = ({ editing, values, onChange }: Form) => {
  const defaultProps: any = {
    variant: 'contained',
    onChange: onChange,
    required: true,
  };

  if (editing === false) return null;
  return (
    <fieldset className="inline-flex items-center gap-4">
      <Input
        name="code"
        label="FIPS Code"
        value={values.code}
        {...defaultProps}
      />
      <Input
        name="county"
        label="County Name"
        value={values.county}
        {...defaultProps}
      />
    </fieldset>
  );
};

const FIPSCodeContent = ({ editing, fipsCode }: Content) => {
  if (editing) return null;
  return (
    <div className="inline-flex items-center gap-4 w-full">
      <SettingTag name={fipsCode.code} color="teal" />
      <p>{fipsCode.county}</p>
    </div>
  );
};
